export enum GenzoCouponCardCtaType {
  ShowCodeButton = "show_code_button",
}
